module.exports = __webpack_public_path__ + "img/resource_management.0ce1509d.jpg";